import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import AppBar from '@mui/material/AppBar';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { useHistory } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import {
  Assessment,
  ShoppingCart,
  Assignment,
  CheckCircle,
  History,
  TrendingUp,
  AccountBalanceWallet,
  MonetizationOn
} from '@material-ui/icons';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid } from 'recharts';
import NavegadorGestao from '../../../components/NavBarGestao';
import api from '../../../services/api';



export default function ContaAdmin() {
  const [meusDados, setMeusDados] = useState([]);

  const [loading, setLoading] = useState(true);

  const [senha, setSenha] = useState('');
  const [confirmesenha, setConfirmeSenha] = useState('');

  const [erroSenha, setErroSenha] = useState(false);
  const [textoErroSenha, setTextoErroSenha] = useState('');

  const [open, setOpen] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [emAutorizacao, setEmAutorizacao] = useState(false);
  const [codigoValidacao, setCodigoValidacao] = useState("");
  const [dashboardData, setDashboardData] = useState(null);
  const [osData, setOsData] = useState(null);


  const title = "Deseja mudar sua senha?";
  const history = useHistory();
  const isMobile = useMediaQuery('(max-width:900px)');

  const regra = Cookies.get('regra') || "";
  const [isCliente, setIsCliente] = useState(() => {
    return regra.toUpperCase().includes("CLIENTE") || regra.toUpperCase().includes("ASSOC_") || regra.toUpperCase().includes("COLABORADOR");
  });

  useEffect(() => {
    async function checkCliente() {
      try {
        const idUsuario = Cookies.get('id_usuario');
        const token = Cookies.get('token');
        if (!idUsuario || !token) return;
        const headers = { Authorization: 'Bearer ' + token };
        const response = await api.get(`/v1/protected/user/retornardadosusuario/${idUsuario}`, { headers });
        if (response.data && response.data.cliente && response.data.cliente.id_cliente) {
           setIsCliente(true);
        }
      } catch (error) {
        console.log("Erro ao checar dados do cliente", error);
      }
    }
    checkCliente();
  }, []);

  const [value, setValue] = React.useState(0);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);

  }


  const handleChangeIndex = (index) => {
    setValue(index);
  };


  async function listarMeusDados() {
    try {

      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      }


      const id_usuario = Cookies.get('id_usuario');
      const mes = new Date().getMonth() + 1;
      const ano = new Date().getFullYear();

      await api.get(`v1/protected/user/retornardadosusuariodashboard/${id_usuario}/${mes}/${ano}`, {
        headers: headers
      }).then(function (response) {
        setMeusDados(response.data.user);
        setDashboardData(response.data);

        if (response.data.jsonOrdemServico) {
          try {
            setOsData(JSON.parse(response.data.jsonOrdemServico));
          } catch (e) {
            console.error("Erro ao fazer parse do JSON de OS", e);
          }
        }

        setLoading(false);
      });



    } catch (_err) {
      // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
      console.log("Erro ao listar seus dados: " + _err)

    }

  }




  const [darkMode, setDarkMode] = useState(() => {
    const saved = Cookies.get('darkMode');
    return saved === 'true';
  });

  const theme = {
    bg: (isMobile || darkMode) ? "#252525" : "#e9eff3",
    paper: (isMobile || darkMode) ? "#2e2e2e" : "#f5f8fa",
    text: (isMobile || darkMode) ? "#ffffff" : "#1a1a1a",
    textSecondary: (isMobile || darkMode) ? "#aaaaaa" : "#5a6a7a",
    border: (isMobile || darkMode) ? "#444444" : "#d1d9e0",
    navbarBg: (isMobile || darkMode) ? "#252525" : "#ffffff",
    navbarVariant: (isMobile || darkMode) ? "dark" : "light",
  };

  useEffect(() => {
    const checkDarkMode = () => {
      const saved = Cookies.get('darkMode');
      setDarkMode(saved === 'true');
    };

    // Listen for custom event dispatch from NavBar
    window.addEventListener('darkModeChanged', checkDarkMode);

    // Also check on focus just in case
    window.addEventListener('focus', checkDarkMode);

    return () => {
      window.removeEventListener('darkModeChanged', checkDarkMode);
      window.removeEventListener('focus', checkDarkMode);
    };
  }, []);

  useEffect(() => {
    listarMeusDados();
  }, []);


  async function validar() {
    try {

      const id_usuario = Cookies.get('id_usuario');

      console.log("id usuario: " + id_usuario);

      if (!codigoValidacao) {
        alert("Digite um Código Valido!");
        return;
      }

      const validador = {
        username: meusDados.login,
        code: parseInt(codigoValidacao),
      }




      const headers = {
        'Authorization': 'Bearer ' + Cookies.get("token")
      }

      const response = await api.post('/v1/protected/validate/key', validador,
        { headers: headers });

      const valido = response.data.valid;
      if (valido) {



        const response_autorizado = await api.put('/v1/protected/users/autorizar/' + meusDados.id_usuario,
          { headers: headers });

        if (response_autorizado) {
          alert("Código Validado, você está autorizado!");
          window.location.reload();
        } else {

        }


      } else {
        alert("Código Inválido!");
      }
    } catch (_err) {
      console.log("erro ao cadastrar: " + _err);
      alert("Erro de Conexão, tente novamente mais tarde");

    }
  }

  async function onConfirm() {
    try {

      const id_usuario = Cookies.get('id_usuario');


      console.log("alterar senha chamado");
      console.log("id usuario: " + id_usuario);
      const cadastro_usuario = {
        senha: senha,
      }

      const headers = {
        'Authorization': 'Bearer ' + Cookies.get("token")
      }

      const response = await api.put('/v1/protected/users/mudarsenha/' + id_usuario, cadastro_usuario,
        { headers: headers });

      const cadastro_salvo = response.data;
      if (cadastro_salvo) {
        alert("Senha alterada com sucesso!");
        Cookies.set('token', undefined);

        history.push({
          pathname: '/login',
        })
      } else {
        alert("Erro de Conexão, tente novamente mais tarde");
      }
    } catch (_err) {
      console.log("erro ao cadastrar: " + _err);
      alert("Erro de Conexão, tente novamente mais tarde");

    }
  }

  function verificar() {
    var senha_valida = validateSenha();

    if (senha_valida) {
      setOpen(true);
    }


  }



  async function autorizar() {


    setEmAutorizacao(true);

    try {

      const id_usuario = Cookies.get('id_usuario');


      console.log("alterar senha chamado");
      console.log("id usuario: " + id_usuario);

      const headers = {
        'Authorization': 'Bearer ' + Cookies.get("token")
      }

      const response = await api.get('/v1/protected/autorizacao/generate/' + id_usuario,
        { headers: headers });

      // console.log(response.data);


      const imageSrc = `data:image/png;base64,${response.data}`;
      //src={`data:image/jpeg;base64,${arquivos.imagem3}`} 
      setQrCodeUrl(imageSrc);



    } catch (_err) {
      console.log("erro ao cadastrar: " + _err);
      alert("Erro de Conexão, tente novamente mais tarde");

    }
  }


  function validateSenha() {
    if (senha.length >= 4) {
      if (senha === confirmesenha) {

        setErroSenha(false);
        setTextoErroSenha('');
        return true;
      } else {

        setErroSenha(true);
        setTextoErroSenha("Senhas não conferem");
        console.log("senhas nao conferem");
        return false;
      }
    } else {
      setErroSenha(true);
      setTextoErroSenha("Senha muito curta");
      console.log("Senha muito curta");
      return false;
    }
  }





  return (
    <div style={{
      backgroundColor: theme.bg,
      minHeight: '100vh',
      transition: 'background-color 0.3s',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <NavegadorGestao inicio={'underline'} corFundo={theme.navbarBg} travado={true} corTexto={theme.text} />


      <div style={{
        paddingTop: isMobile ? '20px' : '5px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Container maxWidth="lg" style={{ backgroundColor: theme.bg, height: '100%', flex: 1 }}>
          {loading ?
            <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
            </Skeleton>
            :
            <div>



              <Grid
                item xs={12}
                container
                direction="row"
                alignItems="center"
                justifyContent={"center"}
              >


                <Box style={{ backgroundColor: theme.navbarBg, width: '100%', alignItems: 'center', }}>
                  <AppBar position="static" style={{ backgroundColor: theme.navbarBg }} >

                    <Tabs
                      value={value}
                      onChange={handleChangeTab}
                      indicatorColor="secondary"
                      textColor="inherit"
                      variant="scrollable"
                      scrollButtons="auto"
                      aria-label="scrollable auto tabs example"


                    >
                      <Tab label="Informações Iniciais" style={{ backgroundColor: theme.paper, color: theme.text }} />
                      <Tab label="Acesso" style={{ backgroundColor: theme.paper, color: theme.text }} />
                      <Tab label="Autorização" style={{ backgroundColor: theme.paper, color: theme.text }} />


                    </Tabs>
                  </AppBar>

                </Box>
              </Grid>

              <SwipeableViews
                index={value}
                onChangeIndex={handleChangeIndex}
                style={{ backgroundColor: theme.bg, width: '100%', alignItems: 'center', color: theme.text }}
              >

                <Grid
                  value={value} index={0}
                  style={{ paddingTop: 10 }}
                  container
                  direction="row"
                  item xs={12}
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >

                  <Grid container spacing={3} style={{ padding: 20 }}>
                    {!isCliente && (
                      <>
                    {/* Dashboard Cards Section */}
                    <Grid item xs={12}>
                      <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 20, color: theme.text, display: 'flex', alignItems: 'center' }}>
                        <TrendingUp style={{ marginRight: 10, color: '#48D1CC' }} /> Visão Geral do Mês
                      </Typography>
                    </Grid>

                    {/* Finance Cards */}
                    <Grid item xs={12} md={6}>
                      <Box style={{
                        background: darkMode ? 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' : 'linear-gradient(135deg, #e0f7fa 0%, #80deea 100%)',
                        borderRadius: 15, padding: 20, color: darkMode ? '#fff' : '#006064',
                        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)'
                      }}>
                        <Typography variant="h6" style={{ display: 'flex', alignItems: 'center' }}>
                          <AccountBalanceWallet style={{ marginRight: 10 }} /> Limites Financeiros
                        </Typography>
                        <Grid container style={{ marginTop: 15 }}>
                          <Grid item xs={6}>
                            <Typography variant="body2">Limite de Compra</Typography>
                            <Typography variant="h6">R$ {dashboardData?.limites?.limitecompra?.toLocaleString('pt-BR') || '0,00'}</Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="body2">Limite Mensal</Typography>
                            <Typography variant="h6">R$ {dashboardData?.limites?.limitemensal?.toLocaleString('pt-BR') || '0,00'}</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Box
                        onClick={() => history.push('/gestao/administracao/ordensdecompras/listar')}
                        style={{
                          background: darkMode ? 'linear-gradient(135deg, #2c3e50 0%, #000000 100%)' : 'linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%)',
                          borderRadius: 15, padding: 20, color: theme.text, border: `1px solid ${theme.border}`,
                          boxShadow: '0 4px 20px rgba(0,0,0,0.1)', cursor: 'pointer'
                        }}
                      >
                        <Typography variant="h6" style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                          <ShoppingCart style={{ marginRight: 10, color: '#fbc02d' }} /> Compras do Mês
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Box style={{
                              textAlign: 'center', p: 1,
                              bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : '#fff9c4',
                              borderRadius: 10, padding: 10,
                              border: `1px solid ${darkMode ? '#444' : '#fff176'}`
                            }}>
                              <Typography variant="caption" style={{ color: theme.textSecondary }}>Solicitado</Typography>
                              <Typography variant="subtitle1" style={{ color: '#f9a825', fontWeight: 'bold' }}>
                                R$ {dashboardData?.limites?.valorcomosolicitante?.toLocaleString('pt-BR') || '0,00'}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={6}>
                            <Box style={{
                              textAlign: 'center', p: 1,
                              bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : '#e8f5e9',
                              borderRadius: 10, padding: 10,
                              border: `1px solid ${darkMode ? '#444' : '#a5d6a7'}`
                            }}>
                              <Typography variant="caption" style={{ color: theme.textSecondary }}>Autorizado</Typography>
                              <Typography variant="subtitle1" style={{ color: '#4caf50', fontWeight: 'bold' }}>
                                R$ {dashboardData?.limites?.valorcomoautorizador?.toLocaleString('pt-BR') || '0,00'}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>

                    {/* OS Stats Section */}
                    <Grid item xs={12} md={8}>
                      <Box style={{
                        backgroundColor: theme.paper, borderRadius: 15, padding: 20,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.05)', color: theme.text
                      }}>
                        <Typography variant="h6" style={{ marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Assignment style={{ marginRight: 10, color: '#2196f3' }} /> Ordens de Serviço (Participação)
                          </div>
                          <Button size="small" style={{ color: '#2196f3' }} onClick={() => history.push('/gestao/administracao/ordensdeservicos/listar')}>Ver Todas</Button>
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Box style={{ textAlign: 'center', p: 1, bgcolor: darkMode ? '#333' : '#f0f4f8', borderRadius: 10, padding: 10 }}>
                              <Typography variant="caption">Criadas</Typography>
                              <Typography variant="h5" style={{ color: '#2196f3' }}>{osData?.totalParticipo || 0}</Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box style={{ textAlign: 'center', p: 1, bgcolor: darkMode ? '#333' : '#f0f4f8', borderRadius: 10, padding: 10 }}>
                              <Typography variant="caption">Abertas</Typography>
                              <Typography variant="h5" style={{ color: '#ff9800' }}>{osData?.totalParticipoAbertas || 0}</Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box style={{ textAlign: 'center', p: 1, bgcolor: darkMode ? '#333' : '#f0f4f8', borderRadius: 10, padding: 10 }}>
                              <Typography variant="caption">Concluídas</Typography>
                              <Typography variant="h5" style={{ color: '#4caf50' }}>{osData?.totalParticipoConcluidas || 0}</Typography>
                            </Box>
                          </Grid>
                        </Grid>

                        {/* OS Chart */}
                        <div style={{ width: '100%', height: 200, marginTop: 20 }}>
                          <ResponsiveContainer>
                            <BarChart data={[
                              { name: 'Criadas', valor: osData?.totalParticipo || 0 },
                              { name: 'Abertas', valor: osData?.totalParticipoAbertas || 0 },
                              { name: 'Concluídas', valor: osData?.totalParticipoConcluidas || 0 }
                            ]}>
                              <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? "#444" : "#ccc"} />
                              <XAxis dataKey="name" stroke={theme.text} />
                              <YAxis stroke={theme.text} />
                              <Tooltip contentStyle={{ backgroundColor: theme.paper, color: theme.text }} />
                              <Bar dataKey="valor" radius={[5, 5, 0, 0]}>
                                {[0, 1, 2].map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={index === 0 ? '#2196f3' : index === 1 ? '#ff9800' : '#4caf50'} />
                                ))}
                              </Bar>
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Box style={{
                        backgroundColor: theme.paper, borderRadius: 15, padding: 20,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.05)', color: theme.text, height: '100%'
                      }}>
                        <Typography variant="h6" style={{ marginBottom: 20, display: 'flex', alignItems: 'center' }}>
                          <Assignment style={{ marginRight: 10, color: '#f44336' }} /> Procedimentos das OS
                        </Typography>
                        <div style={{ width: '100%', height: 200 }}>
                          <ResponsiveContainer>
                            <PieChart>
                              <Pie
                                data={[
                                  { name: 'Não Iniciados', value: dashboardData?.totalProcedimentosAbertos || 0 },
                                  { name: 'Pausados', value: dashboardData?.totalProcedimentosPausados || 0 },
                                  { name: 'Concluídos', value: dashboardData?.totalProcedimentosConcluidos || 0 }
                                ]}
                                innerRadius={60}
                                outerRadius={80}
                                paddingAngle={5}
                                dataKey="value"
                              >
                                <Cell fill="#f44336" />
                                <Cell fill="#ff9800" />
                                <Cell fill="#4caf50" />
                              </Pie>
                              <Tooltip />
                              <Legend verticalAlign="bottom" height={36} />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>
                        <Box style={{ textAlign: 'center', marginTop: 10 }}>
                          <Typography variant="h6">
                            {((dashboardData?.totalProcedimentosAbertos || 0) + (dashboardData?.totalProcedimentosPausados || 0))} Pendentes
                          </Typography>
                          <Button
                            variant="contained"
                            size="small"
                            style={{ marginTop: 10, backgroundColor: '#f44336', color: '#fff' }}
                            onClick={() => window.dispatchEvent(new Event('abrirTarefasBalao'))}
                          >
                            Executar Procedimentos
                          </Button>
                        </Box>
                      </Box>
                    </Grid>

                    {/* Management Tasks Section (New) */}
                    {dashboardData?.totalTarefasAbertas > 0 && (
                      <Grid item xs={12}>
                        <Box style={{
                          backgroundColor: darkMode ? '#333' : '#fffde7',
                          borderRadius: 15, padding: '15px 20px',
                          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                          border: `1px solid ${darkMode ? '#444' : '#fff59d'}`,
                          boxShadow: '0 4px 15px rgba(0,0,0,0.05)'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <CheckCircle style={{ color: '#fbc02d', marginRight: 15 }} />
                            <div>
                              <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: theme.text }}>
                                Tarefas de Gestão Pendentes
                              </Typography>
                              <Typography variant="body2" style={{ color: theme.textSecondary }}>
                                Você possui {dashboardData.totalTarefasAbertas} solicitações de gestão (ex: autorizações) aguardando sua ação.
                              </Typography>
                            </div>
                          </div>
                          <Button
                            variant="outlined"
                            size="small"
                            style={{ borderColor: '#fbc02d', color: '#fbc02d' }}
                            onClick={() => history.push('/gestao/administracao/ordensdecompras/listar')}
                          >
                            Ver Tarefas
                          </Button>
                        </Box>
                      </Grid>
                    )}

                    {/* Last 5 OS List */}
                    <Grid item xs={12}>
                      <Box style={{ backgroundColor: theme.paper, borderRadius: 15, padding: 20, boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                        <Typography variant="h6" style={{ marginBottom: 15, color: theme.text, display: 'flex', alignItems: 'center' }}>
                          <History style={{ marginRight: 10, color: '#9c27b0' }} /> Últimas Ordens de Serviço Abertas
                        </Typography>
                        <Grid container spacing={1}>
                          {osData?.ultimasAbertas?.length > 0 ? osData.ultimasAbertas.map((os, idx) => (
                            <Grid item xs={12} key={idx}>
                              <Box style={{
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                padding: '10px 15px', borderRadius: 10, backgroundColor: darkMode ? '#333' : '#f9f9f9',
                                borderLeft: `5px solid ${os.status === 0 ? '#2196f3' : '#ff9800'}`
                              }}>
                                <Typography variant="body2" style={{ color: theme.text }}>
                                  <strong>#{os.id}</strong> - {os.descricao.substring(0, 60)}{os.descricao.length > 60 ? '...' : ''}
                                </Typography>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  style={{ color: theme.text, borderColor: theme.border }}
                                  onClick={() => history.push(`/gestao/administracao/ordensdeservicos/editar/${os.id}`)}
                                >
                                  Ver
                                </Button>
                              </Box>
                            </Grid>
                          )) : (
                            <Grid item xs={12}>
                              <Typography variant="body2" style={{ color: theme.textSecondary, textAlign: 'center', padding: 20 }}>
                                Nenhuma ordem aberta encontrada.
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Box>
                    </Grid>
                    </>
                    )}

                    <Grid item xs={12}>
                      <Typography variant="h6" component="h2" style={{ fontWeight: 'bold', marginTop: 20, color: theme.text }}>
                        Dados Pessoais
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 20, backgroundColor: theme.paper, padding: 20, borderRadius: 15 }}>
                        <img width={100} height={100} alt={"imgPerfil"} style={{ borderRadius: '50%', objectFit: 'cover' }} src={meusDados?.url_img_perfil}></img>
                        <div>
                          <Typography variant="h6" style={{ color: theme.text }}>{meusDados?.nome_amigavel}</Typography>
                          <Typography variant="body2" style={{ color: theme.textSecondary }}>{meusDados?.email}</Typography>
                        </div>
                      </div>
                    </Grid>
                  </Grid>





                </Grid>

                <Grid
                  value={value} index={1}
                  style={{ paddingTop: 30 }}
                  container
                  direction="row"
                  item xs={12}
                  alignItems="center"
                  justifyContent="center"
                  spacing={2}
                >

                  <Grid item xs={1}>
                  </Grid>

                  <Grid item xs={11}>
                    <Typography style={{ color: theme.text }}>
                      Mudar Senha:
                    </Typography>
                  </Grid>

                  <Grid item xs={1}>
                  </Grid>
                  <Grid item xs={11} style={{ padding: 10, paddingTop: 2 }}>
                    <TextField
                      error={erroSenha}
                      id="password"
                      helperText={textoErroSenha}
                      variant="standard"
                      name="password"
                      fullWidth
                      label="Senha"
                      required
                      type="password"
                      autoComplete="current-password"
                      value={senha}
                      onChange={(e) => setSenha(e.target.value)}
                      inputProps={{ maxLength: 30, minLength: 4, style: { color: theme.text } }}
                      InputLabelProps={{ style: { color: theme.text } }}
                    />
                  </Grid>
                  <Grid item xs={1}>
                  </Grid>
                  <Grid item xs={11} style={{ padding: 10, paddingTop: 2 }}>
                    <TextField
                      error={erroSenha}
                      id="password2"
                      helperText={textoErroSenha}
                      variant="standard"
                      name="password2"
                      fullWidth
                      label="Conferir Senha"
                      required
                      type="password"
                      autoComplete="current-password"
                      value={confirmesenha}
                      onChange={(e) => setConfirmeSenha(e.target.value)}
                      inputProps={{ maxLength: 30, minLength: 4, style: { color: theme.text } }}
                      InputLabelProps={{ style: { color: theme.text } }}
                    />
                  </Grid>

                  <Grid item xs={1} style={{ padding: 30 }}>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => verificar()}
                    > Salvar  </Button>

                  </Grid>

                </Grid>


                <Grid
                  value={value} index={2}
                  style={{ paddingTop: 30 }}
                  container
                  direction="row"
                  item xs={12}
                  alignItems="center"
                  justifyContent="center"
                  spacing={2}
                >
                  {meusDados.autorizado === 0 ?
                    <Grid item xs={12} style={{ padding: 30 }}>

                      <Grid item xs={12} style={{ padding: 30 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={emAutorizacao}
                          onClick={(e) => autorizar()}
                        > Iniciar Autorização  </Button>
                      </Grid>

                      <Grid item xs={12} style={{ padding: 30 }}>
                        <Grid item xs={12} style={{ padding: 30 }}>

                          <div style={{ display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                            {qrCodeUrl && <img alt={'icone_qr_code'} style={{ textAlign: 'center' }} src={qrCodeUrl}></img>}

                          </div>
                        </Grid>

                        <Grid item xs={12} style={{ padding: 30 }}>
                          <Typography style={{ color: theme.text }}>
                            Com o Aplicativo Google Authenticator, escaneia o QRCODE acima e insira um Token para Validar sua Autorização!
                          </Typography>
                        </Grid>

                        <Grid item xs={12} style={{ padding: 5 }}>
                          <TextField
                            id="codigoValidacao"
                            variant="standard"
                            name="codigoValidacao"
                            fullWidth
                            label="Código de Validação"
                            required
                            value={codigoValidacao}
                            onChange={(e) => setCodigoValidacao(e.target.value)}
                            inputProps={{ style: { color: theme.text } }}
                            InputLabelProps={{ style: { color: theme.text } }}
                          />

                        </Grid>
                        <Grid item xs={12} style={{ padding: 30 }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={(e) => validar()}
                          > Validar  </Button>
                        </Grid>

                      </Grid>

                    </Grid>
                    :
                    <div>
                      <Grid item xs={11}>
                        <Typography style={{ color: theme.text }}>
                          Autorização Completa
                        </Typography>
                      </Grid>


                    </div>

                  }

                </Grid>




              </SwipeableViews>




            </div>

          }
        </Container>


        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="confirm-dialog"
          PaperProps={{
            style: {
              backgroundColor: theme.paper,
              color: theme.text,
            },
          }}
        >
          <DialogTitle id="confirm-dialog" style={{ color: theme.text }}>{title}</DialogTitle>
          <DialogContent style={{ color: theme.text }}>
            {"Após modificar a senha, você será deslogado e redirecionado para a página de login"}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => setOpen(false)}
              color="secondary"
            >
              No
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setOpen(false);
                onConfirm();
              }}
              style={{ backgroundColor: darkMode ? '#555' : '#e0e0e0', color: theme.text }}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}